import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
Vue.use(ElementUI);
Vue.config.productionTip = false
/** 左侧菜单 */
import Menu from  '@/components/Menu.vue'
Vue.component('Menu',Menu)
/** 头部 */
import Header from  '@/components/Header.vue'
Vue.component('Header',Header)

// import Vue from 'vue'
import dialogDrag from '@/directives/dialogDrag'

Vue.directive('dialogDrag', dialogDrag)

// 引入公共样式
import './assets/css/common.css'
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
